<template>
	<div class="sidebar-post-wrap">
		<div class="sidebar-post-single">
			<div class="sidebar-post-header">
				<div class="post-author-pic">
					<img :src="require(`@/assets/images/users/${'avatar.png'}`)"  />
				</div>
				<div class="post-author-name">
					<a href="#">
						<h2>Zevanya Kyl</h2>
						<p>@ zvnyakyl</p>
					</a>
				</div>
				<div class="post-author-badges">
					<img :src="require(`@/assets/images/badges/${'verified.svg'}`)"  />
					<img :src="require(`@/assets/images/badges/${'elite.svg'}`)"  />
				</div>
			</div><!-- /. sidebar-post-body -->

			<div class="sidebar-post-body">
				<a href="#">
					<img :src="require(`@/assets/images/posts-img/${'sp1.svg'}`)"  />
					<h2>Voldemort</h2>
					<p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter </p>
					<small>12 days ago</small>
				</a>
			</div><!-- /. sidebar-post-body -->
		</div><!-- /. sidebar-post-single -->
		<div class="sidebar-post-single">
			<div class="sidebar-post-header">
				<div class="post-author-pic">
					<img :src="require(`@/assets/images/users/${'avatar.png'}`)"  />
				</div>
				<div class="post-author-name">
					<a href="#">
						<h2>Zevanya Kyl</h2>
						<p>@ zvnyakyl</p>
					</a>
				</div>
				<div class="post-author-badges">
					<img :src="require(`@/assets/images/badges/${'verified.svg'}`)"  />
					<img :src="require(`@/assets/images/badges/${'elite.svg'}`)"  />
				</div>
			</div><!-- /. sidebar-post-body -->

			<div class="sidebar-post-body">
				<a href="#">
					<img :src="require(`@/assets/images/posts-img/${'sp1.svg'}`)"  />
					<h2>Voldemort</h2>
					<p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter </p>
					<small>12 days ago</small>
				</a>
			</div><!-- /. sidebar-post-body -->
		</div><!-- /. sidebar-post-single -->
		<div class="sidebar-post-single">
			<div class="sidebar-post-header">
				<div class="post-author-pic">
					<img :src="require(`@/assets/images/users/${'avatar.png'}`)"  />
				</div>
				<div class="post-author-name">
					<a href="#">
						<h2>Zevanya Kyl</h2>
						<p>@ zvnyakyl</p>
					</a>
				</div>
				<div class="post-author-badges">
					<img :src="require(`@/assets/images/badges/${'verified.svg'}`)"  />
					<img :src="require(`@/assets/images/badges/${'elite.svg'}`)"  />
				</div>
			</div><!-- /. sidebar-post-body -->

			<div class="sidebar-post-body">
				<a href="#">
					<img :src="require(`@/assets/images/posts-img/${'sp1.svg'}`)"  />
					<h2>Voldemort</h2>
					<p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter </p>
					<small>12 days ago</small>
				</a>
			</div><!-- /. sidebar-post-body -->
		</div><!-- /. sidebar-post-single -->
	</div>
</template>

<script>
  export default {
      	name: "sidebar-post",

		data(){
		    return{
		    	
		    }
		},

		methods: {


		}
  }

</script>